// Vendor
import * as React from 'react';
import { BarSvgProps, ResponsiveBar } from '@nivo/bar';
import { useInView } from 'react-intersection-observer';
import {
  SPOT_BRAND,
  SPOT_CLEANOUT_LIGHTER,
  SPOT_GREEN
} from '@thredup/styleguide/src/variables/colors';

// Internal
import { data } from './data';
import { Bar } from './Bar';
import { DEFAULT_CHART_PROPS } from '@src/config/nivo';

const ChartFastFashion: React.FC = () => {
  // Hooks
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-200px 0px'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialData = data.map((d: any) => ({
    ...d,
    Resale: 0,
    'Traditional Thrift & Donation': 0,
    'Fast Fashion': 0
  }));

  const chartData = inView ? data : initialData;
  const colors = {
    'Fast Fashion': SPOT_CLEANOUT_LIGHTER,
    'Traditional Thrift & Donation': SPOT_GREEN,
    Resale: SPOT_BRAND
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getColors = (bar: any) => (colors as any)[bar.id];

  const barProps: BarSvgProps = {
    ...DEFAULT_CHART_PROPS,
    axisBottom: {
      tickPadding: 10,
      tickSize: 0
    },
    axisLeft: {
      format: (d: number) => (d % 20 === 0 ? `$${d}B` : ''),
      tickPadding: 25,
      tickSize: -15,
      tickValues: [10, 20, 30, 40, 50, 60, 70, 80]
    },
    barComponent: Bar,
    colors: getColors,
    data: chartData,
    enableGridY: true,
    enableGridX: false,
    enableLabel: false,
    gridXValues: [0],
    gridYValues: [0],
    groupMode: 'grouped',
    indexBy: 'year',
    innerPadding: 6,
    isInteractive: true,
    keys: ['Resale', 'Traditional Thrift & Donation', 'Fast Fashion'],
    layout: 'vertical',
    legends: [
      {
        dataFrom: 'keys',
        anchor: 'top-left',
        direction: 'column',
        translateX: 50,
        translateY: 30,
        itemsSpacing: 20,
        itemWidth: 50,
        itemHeight: 20,
        itemDirection: 'left-to-right',
        itemOpacity: 0.85,
        symbolShape: 'circle',
        symbolSize: 28
      }
    ],
    margin: { top: 30, right: 0, bottom: 50, left: 70 },
    maxValue: 80,
    minValue: 0
  };

  return (
    <span ref={ref}>
      <ResponsiveBar {...barProps} />
    </span>
  );
};

export { ChartFastFashion };
